import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { gastosCovid_item } from "../../../json/gastosCovid";
import "../GastosCovid/stylessh.css";

const GastosCovid = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Gastos Covid-19</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row w-100">
        {gastosCovid_item.map((item) => (
          <div className="col-12" key={item.gastosCovid_item_title}>
            <h3>{item.gastosCovid_item_title}</h3>
            <div className="div-table">
            <div className="div-table-row div-table-header">
                <div className="div-table-cell div-table-cell-concepto encabezado-seccion">Concepto</div>
                <div className="div-table-cell div-table-cell-enlace encabezado-seccion-2">Enlace</div>
              </div>
              {item.gastosCovid_item_table.map((tableItem) => (
                <div className="div-table-row" key={tableItem.gastosCovid_item_content}>
                  <div className="div-table-cell div-table-cell-concepto">{tableItem.gastosCovid_item_content}</div>
                  <div className="div-table-cell div-table-cell-enlace">
                    <a className="archivo-dxls" target="_blank" href={tableItem.gastosCovid_item_url_xls}></a>{" "}
                    <a className="archivo-dpdf" target="_blank" href={tableItem.gastosCovid_item_url_pdf}></a>
                  </div>
                  <div className="div-clear"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GastosCovid;
